<template>
 <div class="main">
        <div class="profileHeader">
            <Profile/>
        </div>
  <div class="mainBody">
    <v-card class="card">
    <v-container>
    <div class="avatar">
        <div class="avatarDiv">
       <img src="../assets/avatar.png" alt="teller logo" width="100%" height="100%">
        <div class="btnAv">
            <v-btn color="#ad1684" rounded small dark>
                <v-icon left>mdi-camera</v-icon>
                Change</v-btn>
        </div>
        </div>
    </div>
      <v-row>
        <v-col cols="12" sm="6" md="4">
               <div class="labelDiv">
                 <label>Firstname<span>*</span> </label>
                </div>
                <v-text-field
                disabled
                   :value="User.firstname"
                    class="fieldtx"
                    outlined
                    dense
                ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
           <div class="labelDiv">
                 <label>Middlename<span>*</span> </label>
                </div>
                <v-text-field
                disabled
                  :value="User.middlename"
                    class="fieldtx"
                    outlined
                    dense
                ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="4">
        <div class="labelDiv">
                 <label>Lastname<span>*</span> </label>
                </div>
                <v-text-field
                disabled
                  :value="User.lastname"
                    class="fieldtx"
                    outlined
                    dense
                ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="6">
              <div class="labelDiv">
                 <label>Email Address<span>*</span> </label>
                </div>
                <v-text-field
                disabled
                   :value="User.email"
                    class="fieldtx"
                    outlined
                    dense
                ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="6">
           <div class="labelDiv">
              <label><b>Phone number</b></label>
              </div>
          <v-text-field disabled :value="User.phone" outlined>
          <template  slot="prepend-inner">
          <div class="flag">
            <div>
          <img src="../assets/flag.png" alt="teller logo" width="35" height="25">
            </div>
          <div class="num">
          <p>+234</p>
          </div>
          </div>
          </template>
          </v-text-field>
        </v-col>
      

      </v-row>
    </v-container>
        </v-card>
  </div>
</div>
</template>
<script>
import Profile from '../components/profileHeader'
export default {
     components:{
       Profile:Profile,
     },
      computed: {
       User () {
        return this.$store.getters.getUser
    }
    },
}
</script>
<style scoped>
.main{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
  "profileHeader profileHeader profileHeader" 
  "mainBody mainBody mainBody" 
  "mainBody mainBody mainBody" 
  "mainBody mainBody mainBody" 
  "mainBody mainBody mainBody" 
  "mainBody mainBody mainBody" 
  "mainBody mainBody mainBody" 
  "mainBody mainBody mainBody" 
  ;
}
.profileHeader{
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;

}
.mainBody{
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 50px;
  padding-top: 70px;

}
.avatar{
    display: flex;
    padding: 20px;
    justify-content: center;
}
.avatarDiv{
    position: relative;
}
.btnAv{
   position: absolute;
   top: 80px;
   left: -5px;
}
.avatarDiv img{
height: 100px;
width: 100px;
border-radius: 60px;  
}
.num{
  padding-top: 5px;
}
.labelDiv{
   padding-bottom: 10px;
}
span{
    color:red
}
.card{
    padding: 20px;
    border-radius: 10px !important;
     box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11);
  background-color: #ffffff;
}
.flag{
    display: flex;
    justify-content: center;
    align-items: center;
}
.flag img{
    margin-right: 3px;
}
@media only screen and (max-width: 1024px) {
  .profileHeader{
  border-top-left-radius: 0px;
}
.mainBody{
  border-bottom-left-radius: 0px;
}
}
</style>